import keyMirror from 'keymirror';

export const ActionTypes = keyMirror({
  SET_SITES: null,
});

export interface ISitesState {
  sites: Map<string, Site[]>
}